/**
 * Parse the date portion of a business date string to the machines localised timezone rather than UTC.
 *
 * @param businessDate the date portion of a business date (i.e. `yyyy-mm-dd`).
 */
export const parseBusinessDate = (businessDate) => {
    return new Date(`${businessDate}T00:00:00.000`);
};
//# sourceMappingURL=parse-business-date.js.map